(function($){
	$.fn.trickyfeed = function(options){
		var settings = {
			client_id:'66502d0a12964fddb285ab13639dbeb7',
			load_cookie_result:LoadResultsFromCookie,
			tag_name: 'babes',
			filters:{ users:[], likes:false},
			count: 6,
			enable_cache: false,
			cache_duration: 1,
			cookie_name: 'CachedInstagramPhotos',
			max_next_urls: 8,
			store_mode:false,
			store_liked_media:false,
			store_name:null,
			store_tags:[],
			image_resolution:'thumbnail',
			html_wrappers:{
				Main: '<ul class="clearfix"/>',
				Likes:'<span class="instaLikes"><i class="icon-heart"></i>[LIKESCOUNT]</span>'
			},
			callback:function(){},
			link_photos:true,
			show_likes:false
		};
		
		var self = $(this);
		var nextUrl = '';

		$.extend(settings, options);

		settings.cookie_name = settings.cookie_name+'_'+settings.tag_name+'_'+ settings.store_name;

		var url = 'https://api.instagram.com/v1/tags/'+settings.tag_name+'/media/recent?client_id='+settings.client_id;
		var nextUrlCounter = 0;
		var photos = [];
		var token = null;
		var likedMediaUrl = 'https://api.instagram.com/v1/users/self/media/liked?access_token=';
		var recentMediaUrl = 'https://api.instagram.com/v1/users/self/media/recent/?access_token=';
		var textPlaceholders = {Likes:'[LIKESCOUNT]'};

		var isSessionStorageAvailable = true;
		try{
			sessionStorage.getItem(settings.cookie_name);
		}catch(e){
			isSessionStorageAvailable = false;
		}
		
		var init = function(){
			if(settings.enable_cache && isSessionStorageAvailable){
				var savedHtmlResponse = sessionStorage.getItem(settings.cookie_name);
				//console.log(savedHtmlResponse);
				if(savedHtmlResponse){
					settings.load_cookie_result(savedHtmlResponse);
					settings.callback(null);//fire callback with nul response..
					return false;
				}
			}

			if(settings.store_mode && settings.store_name){
				var tokenRetreivalURL = 'https://cdn.tricky3.io/trickyfeed/app/getoken.php?store='+settings.store_name;
				AjaxWrapper('json',null,tokenRetreivalURL,ShowSpecificUserMedia);
			}else{
				LoadResults(url);
			}

		};

		var LoadResults = function(url){
			AjaxWrapper('jsonp',null,url,MainCallBack);
		};

		var ShowSpecificUserMedia = function(response){
			token = response.token;
			var mediaUrl = settings.store_liked_media ? likedMediaUrl+token : recentMediaUrl+token;
			AjaxWrapper('jsonp',null,mediaUrl,MainCallBack);
		};

		function MainCallBack(response){
			try{
				nextUrl = response.pagination.next_url !== null ? response.pagination.next_url : '';
			}catch(e){nextUrl = '';}

			response = GetFilteredJsonResponse(response);
			ProcessData(response);
		}

		function GetFilteredJsonResponse(response){
			//Filter Liked Media
			if(settings.store_mode){
				if(settings.store_tags.length > 0){
					var taggedFilteredResponse = { data:[] };
					$(response.data).each(function(index, obj){
						for(var i = 0;i< settings.store_tags.length;i++){
							var tag = settings.store_tags[i];
							//console.log(obj.tags);
							if(jQuery.inArray(tag, obj.tags) != -1){
								taggedFilteredResponse.data.push(obj);
							}
						}
					});

					response = taggedFilteredResponse;
				}
			}else{
				//Filtering by user name
				if(settings.filters.users.length){
					var usersFilteredResponse = { data:[] };
					$(response.data).each(function(index, obj){
						if(jQuery.inArray(obj.user.username, settings.filters.users) != -1){
							usersFilteredResponse.data.push(obj);
						}
					});

					response = usersFilteredResponse;
				}

				//Filter by likes
				if(settings.filters.likes){
					var likedFilteredResponse = { data:[] };
					$(response.data).each(function(index, obj){
						if(obj.likes.count > 0){
							likedFilteredResponse.data.push(obj);
						}
					});

					response = likedFilteredResponse;
				}
			}

			return response;
		}

		function LoadResultsFromCookie(savedResponse){
			self.append(savedResponse);
		}

		function ProcessData(response){
			if(response !== null){
				$(response.data).each(function(index, obj){
					if(photos.length == settings.count){
						return false;//break the loop..
					}

					var image = $('<img class="instagraphic"/>');
					var imageSrc = settings.image_resolution == 'lowresolution' ? obj.images.low_resolution.url : settings.image_resolution == 'standardresolution' ? obj.images.standard_resolution.url : obj.images.thumbnail.url;
					image.attr({'src':imageSrc ,'data-href':obj.link,'data-author':obj.user.username});
					if(settings.show_likes && obj.likes && typeof(obj.likes.count) != 'undefined'){
						image.attr('data-likes', obj.likes.count);
					}

					photos.push(image);
				});

				if(photos.length < settings.count && nextUrl !== '' && nextUrlCounter <= settings.max_next_urls){
					LoadResults(nextUrl);
					nextUrlCounter++;
					return;
				}

				var outputHtml = $('<div/>');
				var addListItem = false;

				if(settings.html_wrappers.Main.indexOf('ul') != -1){
					outputHtml.append($(settings.html_wrappers.Main));
					addListItem = true;
				}

				$(photos).each(function(index, photo){
					var output = photo;
					if(settings.link_photos){
						output = $('<a/>');
						output.attr({'href': photo.attr('data-href'),'target':'_blank'});
						output.append(photo);
					}

					if(settings.show_likes){
						output.append($(settings.html_wrappers.Likes.replace(textPlaceholders.Likes, photo.attr('data-likes'))));
					}

					if(addListItem){
						$('ul', outputHtml).append($('<li/>').append(output));
					}else{
						outputHtml.append(output);
					}
				});

				self.append(outputHtml.html());

				if(settings.enable_cache && isSessionStorageAvailable){
					sessionStorage.setItem(settings.cookie_name, outputHtml.html());
				}

				settings.callback(response);

			}else{
				settings.callback(response);
			}
		}

		var AjaxWrapper = function(dataType,type,url,callback){
			$.ajax({
				dataType:dataType,
				url:url,
				cache:false,
				success:function(response){
					callback(response);
				}
			});
		};

		init();

	};
})(jQuery);